import { CButton, CContainer, CNavbar,CRow,CCol, CImage} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons';
import './../css/bop/complaint.css'
import '@coreui/coreui/dist/css/coreui.min.css'
import logo from './../img/bop-logo.png'
import { useHistory } from 'react-router-dom';
import {  useEffect  } from 'react';

function Complaint() {

const history = useHistory();

const  ComplainForm = () => {
    let path = '/form';
    history.push({
        pathname: path
      });
}
useEffect( () => {
  document.title="BOP Co., Ltd."
  window.scrollTo(0, 0)
}, []);


  return (
    <div className="Compaint" style={{height:"100vh",background:"#282C34"}}>
      <header>
      <CNavbar >
        <div className="marginleft20 mt-2">
        <CImage src={logo} width={80} height={80} />
        </div>
      </CNavbar>
      </header>
        <div style={{minHeight:"100%",background:"#282C34"}}>
        <CContainer >
          <div >
        <CRow className="mt-5">
          <CCol  lg={12}>
          <label className="TitleCompaint"><b>ระบบรับร้องเรียนและแจ้งเบาะแส BOP</b></label>
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol lg={12}>
          <label>ท่านสามารถร้องเรียนหรือแจ้งเบาะแสเกี่ยวกับการกระทำผิดกฏหมาย หรือการไม่ปฏิบัติตามนโยบายของ BOP ในเรื่อง บรรษัทภิบาล จรรยาบรรณในการดำเนินธุรกิจการต่อต้านคอร์รัปชั่น/ทุจริต และจรรยาบรรณคู่ธุรกิจ โดยบริษัทจะรักษาข้อมูลของท่านเป็นอย่างดี และดำเนินการอย่างรัดกุมต่อไป</label> 
          </CCol>          
        </CRow>
        <CRow className="mt-4">
          <CCol lg={12}>
          <label>ช่องทางนี้ไม่รับพิจารณาข้อร้องเรียนเรื่องคุณภาพสินค้าหรือการให้บริการ โปรดติดต่อผู้จำหน่ายหรือให้บริการโดยตรง ทั้งนี้ ผู้ร้องเรียนต้องเปิดเผยชื่อและแจ้งข้อมูลที่เป็นความจริง ไม่กล่าวหาผู้อื่นโดยไม่มีหลักฐานที่ชัดเจนเพียงพอ</label> 
          </CCol>          
        </CRow>
        <CRow className="mt-4 mb-5 ">
          <CCol lg={12}>
          <label>"ผู้ร้องเรียนควรกรอกข้อมูลเท่าที่จะกระทำได้ เพื่อให้สามารถนำไปสอบหาข้อเท็จจริงได้ โดยควรเปิดเผยชื่อ ที่อยู่ของตนเอง หรือช่องทางการติดต่ออื่นๆ เพื่อให้บริษัทสามารถสอบถามข้อมูลเพิ่มเติมได้ อย่างไรก็ตามผู้ร้องเรียนสามารถเลือกที่จะเปิดเผยหรือไม่เปิดเผยชื่อของตนเองก็ได้"</label> 
          </CCol>          
        </CRow>
          <CButton  onClick={ComplainForm} size="lg" className="color-btn" shape="rounded-pill"><CIcon icon={cilPencil} style={{marginRight:7.5}} size="lg"/>แจ้งข้อร้องเรียนและเบาะแส</CButton>
        <CRow className="mt-5">
          <CCol lg={12}>
          <label>ช่องทางการร้องเรียนเพิ่มเติม</label> 
          </CCol>          
        </CRow>
        <CRow className="mt-4">
          <CCol lg={12}>
          <label>สถานที่ตั้ง : เลขที่ 54 อาคาร บี บี บิลดิ้ง ชั้น 18 ห้องเลขที่ 1813 ถนน สุขุมวิท 21 (อโศก) แขวงคลองเตยเหนือ เขตวัฒนา กรุงเทพมหานคร 10110</label> 
          </CCol>          
        </CRow>
        <CRow className="mt-4">
          <CCol lg={12}>
          <label>อีเมล : whistleblowing@bop.co.th</label> 
          </CCol>          
        </CRow>
        </div>
        </CContainer>
        
      </div>
    </div>
  );
}

export default Complaint;

